import React, { useContext, useState } from "react";
import { Input, ToastError, ToastSuccess } from "../global/component";
import { Link, useNavigate } from "react-router";
import {
  LoginService,
  RequestOtpService,
  ResetPasswordService,
  UpdatePasswordService,
} from "../models/ApiService";
import FreeTips from "./FreeTips";
import AuthContext from "../global/auth-context";
import { Analytics } from "@vercel/analytics/react";

const ForgotPassword = () => {
  const [email, setEmail] = useState(null);
  const [otp1, setOtp1] = useState(null);
  const [otp2, setOtp2] = useState(null);
  const [otpExpiry, setOtpExpiry] = useState(null);
  const [password1, setPassword1] = useState(null);
  const [password2, setPassword2] = useState(null);
  const [passwordReset, setPasswordReset] = useState(false);
  const [emailVerify, setEmailVerify] = useState(false);
  let navigate = useNavigate();

  async function ResetPassWordFunction(params) {
    // Validate email field
    if (!email) {
      ToastError("Email is required.");
    } else if (!/@\S+\.\S+/.test(email)) {
      ToastError("Email is invalid.");
    } else {
      let response = await ResetPasswordService(email);
      if (response.success == true) {
        ToastSuccess(response.message);
        setOtp1(response.data.OtpObj.otpNumber);
        setOtpExpiry(response.data.OtpObj.otpExpiry);
        console.log(response);
        setPasswordReset(true);
      } else {
        ToastError(response.message);
      }
    }
  }
  async function VerifyEmailFunction(params) {
    let CurrentTime = new Date(Date.now());
    let ExpiryTime = new Date(otpExpiry);

    if (!otp2) {
      ToastError("Enter Otp.");
    } else if (otp2 != otp1) {
      ToastError("Otp is incorrect.");
    } else if (CurrentTime > ExpiryTime && otp2 == otp1) {
      ToastError("Otp expired.");
    } else if (CurrentTime <= ExpiryTime && otp2 == otp1) {
      ToastSuccess("Otp verified.");
      setEmailVerify(true);
    }
  }

  async function ChangePassWordFunction(params) {
    // Validate password field
    if (!password1) {
      ToastError("New Password is required.");
    } else if (password1.length < 6) {
      ToastError("Password must be at least 6 characters.");
    } else if (!password2) {
      ToastError("confirm password is required.");
    } else if (password2.length < 6) {
      ToastError("passwords do not match.");
    } else if (password1 != password2) {
      ToastError("passwords do not match.");
    } else {
      let payload = { email, password2 };
      let response = await UpdatePasswordService(payload);
      if (response.success == true) {
        ToastSuccess(response.message);
        navigate("/login");
        console.log(response);
      } else {
        ToastError(response.message);
      }
    }
  }
  async function ResendOtpFunction(params) {
    let response = await RequestOtpService(email);
    if (response.success == true) {
      ToastSuccess(response.message);
      setOtp1(response.data.OtpObj.otpNumber);
      setOtpExpiry(response.data.OtpObj.otpExpiry);
      console.log(response);
    } else {
      ToastError(response.message);
    }
  }

  return (
    <div className="bg-myLightGreen h-screen px-5 py-20 lg:py-20 flex justify-center overflow-y-auto">
      <Analytics />
      {passwordReset == false && (
        <div className="w-full flex flex-col md:w-1/2 gap-10 ">
          <text className="font-bold text-xl md:text-2xl text-myNormalGreen">
            Reset Your Password
          </text>
          <div className="flex gap-5 flex-col">
            <div className="flex">
              <Input
                placeholder={"Email"}
                type={"email"}
                borderColor={"#016401"}
                value={email}
                onchange={setEmail}
              />
            </div>
          </div>
          <Link
            onClick={ResetPassWordFunction}
            type="submit"
            className="md:py-2 self-center bg-myNormalGreen py-1 text-white font-bold text-lg w-full text-center rounded-xl"
          >
            Reset Password
          </Link>
        </div>
      )}
      {passwordReset && emailVerify == false && (
        <div className="w-full flex flex-col md:w-1/2 gap-10 ">
          <text className="font-bold text-xl md:text-2xl text-myNormalGreen">
            Verify Email
          </text>
          <div className="flex gap-5 flex-col">
            <div className="flex flex-col gap-4">
              <Input
                placeholder={"Enter Otp"}
                type={"text"}
                borderColor={"#016401"}
                value={otp2}
                onchange={setOtp2}
              />
              <a
                onClick={ResendOtpFunction}
                className="text-myNormalGreen text-end -mt-3 px-3 font-medium"
              >
                Resend Otp
              </a>
            </div>
          </div>
          <Link
            onClick={VerifyEmailFunction}
            type="submit"
            className="md:py-2 self-center bg-myNormalGreen py-1 text-white font-bold text-lg w-full text-center rounded-xl"
          >
            Verify Email
          </Link>
        </div>
      )}
      {passwordReset && emailVerify && (
        <div className="w-full flex flex-col md:w-1/2 gap-10 ">
          <text className="font-bold text-xl md:text-2xl text-myNormalGreen">
            Change Your Password
          </text>
          <div className="flex gap-5 flex-col">
            <Input
              placeholder={"New Password"}
              type={"password"}
              borderColor={"#016401"}
              value={password1}
              onchange={setPassword1}
            />
            <Input
              placeholder={" Confirm New Password"}
              type={"password"}
              borderColor={"#016401"}
              value={password2}
              onchange={setPassword2}
            />
          </div>
          <a
            onClick={ChangePassWordFunction}
            type="submit"
            className="md:py-2 self-center bg-myNormalGreen py-1 text-white font-bold text-lg w-full text-center rounded-xl"
          >
            Change Password
          </a>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
